export const intro = {
  paragraph: `We are dedicated to engaging with our community and partners. Feel free to contact our team for inquiries, collaborations, and support. Here's how you can connect with us:`,
};
